import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import "./style.css";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Divider from '@mui/material/Divider';
import PropagateLoader from "react-spinners/PropagateLoader";
import LockIcon from '@mui/icons-material/Lock';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {useDispatch} from 'react-redux';
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";


export default function Login(){
    const [username,setName] = useState("")
    const [password,setPass] = useState("")
    const [error,setError] = useState("")
    const [success,setSuccess] = useState("")
    const [loading,setLoading] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    async function postName(e){
        setLoading(true)
        e.preventDefault()

        try{
        const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/login`,{
            username, password
        });
        setLoading(false)
        setSuccess("Login Berhasil")
        setError("")
        setName("")
        setPass("")
        const {message,...rest}=data;
        setTimeout(()=>{
            dispatch({type:"LOGIN", payload: rest});
            Cookies.set("user",JSON.stringify(rest));
            navigate("/");
        },2000)
        }catch(error){
        setLoading(false);
        setSuccess("")
        if(error.response.data.message === "Username tidak terdaftar"){
            setError("Username tidak terdaftar")
        }else{
            setError("Password Salah")
        }
        setPass("")
        }
    };
    
    return  <Grid container justifyContent="center"  align="center" alignItems="center">
                <Grid item lg={3} p={3} align="center" justifyContent="center">
                    <h3 justifyContent="center">Login Backend</h3>
                    <form onSubmit={postName}>
                    <TextField type="text" sx={{ mt: 2 }} value={username} onChange={(e) => setName(e.target.value)} variant="outlined" fullWidth label="username"/>
                    <TextField type="password" sx={{ mt: 2 }}  fullWidth  label="Password" variant="outlined" value={password} onChange={(e) => setPass(e.target.value)} InputProps={{endAdornment: (
                        <InputAdornment position="end">
                            <LockIcon />
                        </InputAdornment>
                    ),
                    }}/>
                    <Button sx={{ mt: 2 }} type="submit" variant="contained">Login</Button>
                    <PropagateLoader color="#1876f2" loading={loading} size={10}/>
                    {error && <div className="error_text">{error}</div>}
                    {success && <div className="success_text">{success}</div>}
                    </form>
                </Grid>

            </Grid>
};